import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import FileAttachments from '../components/FileAttachments';
import InformesMensualesSection from '../components/InformesMensualesSection';
import { Bug, Plus, XCircle, CheckCircle2, ChevronDown, ChevronUp, Paperclip, Pencil, Trash2, AlertCircle } from 'lucide-react';
import { ModalEliminarRegistro, esAdmin } from '../components/RegistroAcciones';

function ModalPlagas({ onClose, onGuardado }) {
  const today = new Date().toISOString().split('T')[0];
  const [form, setForm] = useState({
    empresa: '', numero_contrato: '', fecha_revision: today,
    tipo_revision: 'Control preventivo', resultado: 'satisfactorio',
    incidencias: '', medidas_correctoras: '', proxima_revision: '',
    responsable: '', observaciones: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [savedId, setSavedId] = useState(null);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const guardar = async () => {
    if (!form.empresa || !form.fecha_revision) { setError('Empresa y fecha son obligatorias'); return; }
    setLoading(true);
    try {
      const res = await api.post('/registros/plagas', form);
      setSavedId(res.data.id);
    } catch (e) { setError(e.response?.data?.error || 'Error'); }
    finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal modal-lg">
        <div className="modal-header">
          <h2 style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Bug size={18} color="var(--color-primary)" /> Nueva Revisión Control de Plagas
          </h2>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><XCircle size={18} /></button>
        </div>
        <div className="modal-body">
          {error && <div className="alert alert-danger">{error}</div>}
          {savedId && (
            <div className="alert alert-success">
              <CheckCircle2 size={16} /> Revisión guardada. Adjunta el contrato o informe de la empresa.
            </div>
          )}
          <div className="form-grid">
            <div className="form-group"><label className="form-label">Empresa contratada <span className="required">*</span></label>
              <input className="form-control" value={form.empresa} onChange={e => set('empresa', e.target.value)} disabled={!!savedId} /></div>
            <div className="form-group"><label className="form-label">Nº Contrato</label>
              <input className="form-control" value={form.numero_contrato} onChange={e => set('numero_contrato', e.target.value)} disabled={!!savedId} /></div>
          </div>
          <div className="form-grid">
            <div className="form-group"><label className="form-label">Fecha revisión <span className="required">*</span></label>
              <input type="date" className="form-control" value={form.fecha_revision} onChange={e => set('fecha_revision', e.target.value)} disabled={!!savedId} /></div>
            <div className="form-group">
              <label className="form-label">Tipo de revisión</label>
              <select className="form-control" value={form.tipo_revision} onChange={e => set('tipo_revision', e.target.value)} disabled={!!savedId}>
                <option>Control preventivo</option><option>Control correctivo</option>
                <option>Inspección periódica</option><option>Tratamiento especial</option>
              </select>
            </div>
          </div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Resultado</label>
              <select className="form-control" value={form.resultado} onChange={e => set('resultado', e.target.value)} disabled={!!savedId}>
                <option value="satisfactorio">✅ Satisfactorio</option>
                <option value="con_incidencias">⚠ Con incidencias</option>
                <option value="no_satisfactorio">❌ No satisfactorio</option>
              </select>
            </div>
            <div className="form-group"><label className="form-label">Próxima revisión</label>
              <input type="date" className="form-control" value={form.proxima_revision} onChange={e => set('proxima_revision', e.target.value)} disabled={!!savedId} /></div>
          </div>
          <div className="form-group"><label className="form-label">Incidencias detectadas</label>
            <textarea className="form-control" rows={3} value={form.incidencias} onChange={e => set('incidencias', e.target.value)} disabled={!!savedId} /></div>
          <div className="form-group"><label className="form-label">Medidas correctoras adoptadas</label>
            <textarea className="form-control" rows={3} value={form.medidas_correctoras} onChange={e => set('medidas_correctoras', e.target.value)} disabled={!!savedId} /></div>
          <div className="form-group"><label className="form-label">Responsable LOMHIFAR</label>
            <input className="form-control" value={form.responsable} onChange={e => set('responsable', e.target.value)} disabled={!!savedId} /></div>
          <div className="form-group"><label className="form-label">Observaciones</label>
            <textarea className="form-control" rows={2} value={form.observaciones} onChange={e => set('observaciones', e.target.value)} disabled={!!savedId} /></div>

          <FileAttachments
            seccion="plagas" entidadTipo="plagas" entidadId={savedId}
            label="Adjuntar contrato / informe de revisión (PDF)"
          />
        </div>
        <div className="modal-footer">
          {!savedId ? (
            <>
              <button className="btn btn-outline" onClick={onClose}>Cancelar</button>
              <button className="btn btn-primary" onClick={guardar} disabled={loading}>
                {loading ? <div className="spinner" style={{ width: 16, height: 16 }} /> : <CheckCircle2 size={16} />} Guardar
              </button>
            </>
          ) : (
            <>
              <button className="btn btn-outline" onClick={onClose}>Cerrar sin más archivos</button>
              <button className="btn btn-primary" onClick={onGuardado}><CheckCircle2 size={16} /> Finalizar</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}


// ═══════════════════════════════════════════════════════════════
// MODAL: Editar revisión de plagas (admin + contraseña)
// ═══════════════════════════════════════════════════════════════
function ModalEditarPlagas({ registro, onClose, onActualizado }) {
  const [form, setForm] = useState({
    empresa: registro.empresa || '',
    numero_contrato: registro.numero_contrato || '',
    fecha_revision: registro.fecha_revision,
    tipo_revision: registro.tipo_revision || 'Control preventivo',
    resultado: registro.resultado || 'satisfactorio',
    incidencias: registro.incidencias || '',
    medidas_correctoras: registro.medidas_correctoras || '',
    proxima_revision: registro.proxima_revision || '',
    responsable: registro.responsable || '',
    observaciones: registro.observaciones || ''
  });
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleGuardar = async () => {
    if (!password) { setError('Debes introducir tu contraseña'); return; }
    setLoading(true); setError('');
    try {
      await api.put(`/registros/plagas/${registro.id}`, { ...form, password });
      onActualizado();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al actualizar');
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal modal-lg">
        <div className="modal-header">
          <h2 style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Pencil size={20} color="#3b82f6" /> Editar Revisión Control de Plagas
          </h2>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><XCircle size={18} /></button>
        </div>
        <div className="modal-body">
          <div className="alert alert-warning" style={{ fontSize: '0.85rem' }}>
            <AlertCircle size={16} /> <strong>Acción restringida:</strong> Solo administradores. Se requiere contraseña.
          </div>

          <div className="form-grid">
            <div className="form-group"><label className="form-label">Empresa</label>
              <input className="form-control" value={form.empresa} onChange={e => set('empresa', e.target.value)} /></div>
            <div className="form-group"><label className="form-label">Nº Contrato</label>
              <input className="form-control" value={form.numero_contrato} onChange={e => set('numero_contrato', e.target.value)} /></div>
          </div>
          <div className="form-grid">
            <div className="form-group"><label className="form-label">Fecha revisión</label>
              <input type="date" className="form-control" value={form.fecha_revision} onChange={e => set('fecha_revision', e.target.value)} /></div>
            <div className="form-group">
              <label className="form-label">Tipo de revisión</label>
              <select className="form-control" value={form.tipo_revision} onChange={e => set('tipo_revision', e.target.value)}>
                <option>Control preventivo</option><option>Control correctivo</option>
                <option>Inspección periódica</option><option>Tratamiento especial</option>
              </select>
            </div>
          </div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Resultado</label>
              <select className="form-control" value={form.resultado} onChange={e => set('resultado', e.target.value)}>
                <option value="satisfactorio">✅ Satisfactorio</option>
                <option value="con_incidencias">⚠ Con incidencias</option>
                <option value="no_satisfactorio">❌ No satisfactorio</option>
              </select>
            </div>
            <div className="form-group"><label className="form-label">Próxima revisión</label>
              <input type="date" className="form-control" value={form.proxima_revision} onChange={e => set('proxima_revision', e.target.value)} /></div>
          </div>
          <div className="form-group"><label className="form-label">Incidencias</label>
            <textarea className="form-control" rows={2} value={form.incidencias} onChange={e => set('incidencias', e.target.value)} /></div>
          <div className="form-group"><label className="form-label">Medidas correctoras</label>
            <textarea className="form-control" rows={2} value={form.medidas_correctoras} onChange={e => set('medidas_correctoras', e.target.value)} /></div>
          <div className="form-group"><label className="form-label">Responsable</label>
            <input className="form-control" value={form.responsable} onChange={e => set('responsable', e.target.value)} /></div>
          <div className="form-group"><label className="form-label">Observaciones</label>
            <textarea className="form-control" rows={2} value={form.observaciones} onChange={e => set('observaciones', e.target.value)} /></div>

          <div className="form-group" style={{ marginTop: 16, padding: 12, background: '#fef3c7', borderRadius: 8, borderLeft: '4px solid #f59e0b' }}>
            <label className="form-label" style={{ color: '#92400e', fontWeight: 600 }}>🔐 Confirma con tu contraseña</label>
            <input type="password" className="form-control" value={password} onChange={e => setPassword(e.target.value)} placeholder="Tu contraseña actual" />
          </div>

          {error && <div className="alert alert-danger">{error}</div>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>Cancelar</button>
          <button className="btn btn-primary" onClick={handleGuardar} disabled={loading || !password}>
            {loading ? <div className="spinner" style={{ width: 16, height: 16 }} /> : <CheckCircle2 size={16} />}
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
  );
}

function FilaPlagas({ r, isAdmin, onEditar, onEliminar }) {
  const [expanded, setExpanded] = useState(false);
  const resultadoColor = { satisfactorio: 'badge-firmado', con_incidencias: 'badge-pendiente_firma', no_satisfactorio: 'badge-rechazado' };
  const resultadoLabel = { satisfactorio: 'Satisfactorio', con_incidencias: 'Con incidencias', no_satisfactorio: 'No satisfactorio' };

  return (
    <>
      <tr>
        <td>{new Date(r.fecha_revision).toLocaleDateString('es-ES')}</td>
        <td style={{ fontWeight: 600 }}>{r.empresa}</td>
        <td style={{ fontSize: '0.82rem' }}>{r.tipo_revision}</td>
        <td style={{ fontSize: '0.82rem', fontFamily: 'var(--font-mono)' }}>{r.numero_contrato || '—'}</td>
        <td><span className={`badge ${resultadoColor[r.resultado]}`}>{resultadoLabel[r.resultado]}</span></td>
        <td style={{ fontSize: '0.82rem', color: r.proxima_revision ? 'var(--color-warning)' : 'var(--color-text-3)', fontWeight: r.proxima_revision ? 600 : 400 }}>
          {r.proxima_revision ? new Date(r.proxima_revision).toLocaleDateString('es-ES') : '—'}
        </td>
        <td style={{ fontSize: '0.78rem', color: r.incidencias ? 'var(--color-danger)' : 'var(--color-text-3)', maxWidth: 160 }}>
          {r.incidencias || '✓ Sin incidencias'}
        </td>
        <td>
          <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <FileAttachments seccion="plagas" entidadTipo="plagas" entidadId={r.id} compact />
            <button className="btn btn-ghost btn-icon btn-sm" onClick={() => setExpanded(!expanded)}>
              {expanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
            </button>
            {isAdmin && (
              <>
                <button className="btn btn-ghost btn-icon btn-sm" onClick={() => onEditar(r)} title="Editar (admin)" style={{ color: '#3b82f6' }}>
                  <Pencil size={13} />
                </button>
                <button className="btn btn-ghost btn-icon btn-sm" onClick={() => onEliminar(r)} title="Eliminar (admin)" style={{ color: 'var(--color-danger)' }}>
                  <Trash2 size={13} />
                </button>
              </>
            )}
          </div>
        </td>
      </tr>
      {expanded && (
        <tr>
          <td colSpan={8} style={{ padding: '0 14px 14px', background: 'var(--color-gray-1)' }}>
            <FileAttachments seccion="plagas" entidadTipo="plagas" entidadId={r.id} label="Subir contrato o informe de revisión" />
          </td>
        </tr>
      )}
    </>
  );
}

export default function PlagasPage() {
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editarRegistro, setEditarRegistro] = useState(null);
  const [eliminarRegistro, setEliminarRegistro] = useState(null);
  const [success, setSuccess] = useState('');
  const isAdmin = esAdmin();

  const load = () => { setLoading(true); api.get('/registros/plagas').then(r => setRegistros(r.data)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <h1 style={{ display: 'flex', alignItems: 'center', gap: 10 }}><Bug size={24} color="var(--color-primary)" />Control de Plagas y Desratización</h1>
          <p>{registros.length} revisiones · Adjunta contratos e informes de la empresa de control de plagas</p>
        </div>
        <button className="btn btn-primary" onClick={() => setModal(true)}><Plus size={16} /> Nueva Revisión</button>
      </div>

      {success && <div className="alert alert-success" style={{ marginBottom: 16 }}><CheckCircle2 size={16} /> {success}</div>}

      {/* Sección de Informes Mensuales (reutilizable) */}
      <InformesMensualesSection tipo="plagas" />

      <div className="card">
        {loading ? <div className="loading-overlay"><div className="spinner" /></div> :
          registros.length === 0 ? (
            <div className="empty-state"><Bug size={48} /><h3>Sin revisiones registradas</h3></div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Fecha</th><th>Empresa</th><th>Tipo</th><th>Contrato</th>
                    <th>Resultado</th><th>Próxima revisión</th><th>Incidencias</th>
                    <th><Paperclip size={13} /></th>
                  </tr>
                </thead>
                <tbody>
                  {registros.map(r => <FilaPlagas key={r.id} r={r} isAdmin={isAdmin} onEditar={setEditarRegistro} onEliminar={setEliminarRegistro} />)}
                </tbody>
              </table>
            </div>
          )
        }
      </div>
      {modal && <ModalPlagas onClose={() => setModal(false)} onGuardado={() => { setModal(false); load(); }} />}
      {editarRegistro && <ModalEditarPlagas registro={editarRegistro} onClose={() => setEditarRegistro(null)} 
        onActualizado={() => { setEditarRegistro(null); load(); setSuccess('Revisión actualizada'); setTimeout(() => setSuccess(''), 3000); }} />}
      {eliminarRegistro && <ModalEliminarRegistro 
        endpoint={`/registros/plagas/${eliminarRegistro.id}`}
        descripcion={`${new Date(eliminarRegistro.fecha_revision).toLocaleDateString('es-ES')} · ${eliminarRegistro.empresa} · ${eliminarRegistro.tipo_revision || ''}`}
        onClose={() => setEliminarRegistro(null)} 
        onEliminado={() => { setEliminarRegistro(null); load(); setSuccess('Revisión eliminada'); setTimeout(() => setSuccess(''), 3000); }} />}
    </div>
  );
}
